<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { PopoverContent, type PopoverContentProps } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = withDefaults(
    defineProps<PopoverContentProps & { class?: HTMLAttributes['class'] }>(),
    {
        align: 'center',
        sideOffset: 4,
    },
)
</script>

<template>
    <PopoverContent
        v-bind="{ ...props, class: undefined }"
        :class="
            cn(
                'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none',
                props.class,
            )
        "
    >
        <slot />
    </PopoverContent>
</template>
